<div class="loader-licenses" *ngIf="infractionsLoading">
  <app-loader></app-loader>
</div>
<div class="row" style="padding-bottom: 45px;" *ngIf="infractionsData.length > 0 && !infractionsLoading">
  <div class="col-11 offset-1">
    <div class="row">

      <div class="col-md-3 title-infringement pos-abs">
        <h1 class="u-mb30 txt txt--title infringement-title">
          Infracciones
        </h1>
      </div>
      <!-- <div class=" col-md-5" *ngIf="infractionsData.length > 0">
        <a *ngIf="requestType !== 'search'" (click)=" downloadInfractionsPdf()" class="download global-hand">
          Descargar PDF
        </a>
      </div> -->
      <div class="offset-md-8 col-md-4" *ngIf="requestType === 'search'" >
        <!-- <button type="button" (click)="onShowForm(0)" class="btn btn--primary btn-infringement"> -->
          <a class="btn btn--primary full-width" (click)="onShowForm(0)" *ngIf="shouldShowCreateNewInfraction">
            <span>Registrar nueva infracción</span>
            <!-- <span class="global-unmount">Modificar o eliminar infracción</span> -->
          </a>
        <!-- </button> -->
      </div>
    </div>

  </div>
</div>

<div *ngIf="infractionsData.length === 0 && !infractionsLoading">
  <h1 class="u-mb30 txt txt--title"> Infracciones </h1>
  <p *ngIf="infractionsError !== ''"> {{infractionsError}} </p>
  <p *ngIf="infractionsError === ''">No hay infracciones registradas.</p>
  <a *ngIf="shouldShowCreateNewInfraction" class="btn btn--primary btn-infringement" (click)="onShowForm(0)" >Registrar nueva infracción</a>
</div>


<div *ngIf="infractionsData.length > 0 && !infractionsLoading">
  <div class="infringement" [ngClass]="{'u-bt u-bt--grey': i === 0}"
    *ngFor="let infraction of infractionsData | slice: 0 : infractionsPagination;index as i;">

    <app-infringement-card [infraction]="infraction" [infractionIndex]="i" [cardType]="requestType">
    </app-infringement-card>
    <div class="row" *ngIf="infraction.infractionState === 1">
      <div class="col-11 offset-1">
        <div class="row">
          <div class="offset-md-8 col-md-4 ">
            <a *ngIf="requestType === 'search'" class="btn btn--primary toggle btn-infringement full-width" data-id="tab-two-b"
              (click)="onShowForm(infraction.id!)">
              Modificar o eliminar infracción
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="u-center u-mt50" *ngIf="infractionsData.length > infractionsPagination && infractionsData.length > 3">
  <a (click)="showMoreInfractions(true)" class="txt txt--paragraph">
    <strong>
      Ver más infracciones +
    </strong>
  </a>
</div>
<div class="u-center u-mt50" *ngIf="infractionsData.length <= infractionsPagination && infractionsData.length > 3">
  <a (click)="showMoreInfractions(false)" class="txt txt--paragraph">
    <strong>
      Ver menos infracciones -
    </strong>
  </a>
</div>
